import {
    getChartCMDBGlobalCake,
    getChartCMDBGlobalLast13Months,
    getCMDBBackupCakeChart,
    getCMDBBackupLast13mChart,
    getCMDBMonitoringCakeChart,
    getCMDBMonitoringLast13mChart,
    getCMDBPatchCakeChart,
    getCMDBPatchLast13mChart
} from 'containers/cmdb/config/charts';

import {invalidateCMDBGlobalCake} from 'modules/store/CMDBGlobalCake';
import {invalidateCMDBGlobalLast13Months} from 'modules/store/CMDBGlobalLast13Months';
import {invalidateCMDBBackupCake} from 'modules/store/CMDBBackupCake';
import {invalidateCMDBBackupLast13m} from 'modules/store/CMDBBackupLast13m';
import {invalidateCMDBMonitoringCake} from 'modules/store/CMDBMonitoringCake';
import {invalidateCMDBMonitoringLast13m} from 'modules/store/CMDBMonitoringLast13m';
import {invalidateCMDBPatchCake} from 'modules/store/CMDBPatchCake';
import {invalidateCMDBPatchLast13m} from 'modules/store/CMDBPatchLast13m';
import {invalidateCMDBServiceDetails} from 'modules/store/CMDBServiceDetails';
import {invalidateCMDBDeviceDetails} from 'modules/store/CMDBDeviceDetails';


export const invalidateCMDB = () => dispatch => {
    dispatch(invalidateCMDBGlobalCake());
    dispatch(invalidateCMDBGlobalLast13Months());
    dispatch(invalidateCMDBBackupCake());
    dispatch(invalidateCMDBBackupLast13m());
    dispatch(invalidateCMDBMonitoringCake());
    dispatch(invalidateCMDBMonitoringLast13m());
    dispatch(invalidateCMDBPatchCake());
    dispatch(invalidateCMDBPatchLast13m());
    dispatch(invalidateCMDBServiceDetails());
    dispatch(invalidateCMDBDeviceDetails());
};

const CREATE_CMDB_GLOBAL_CAKE = 'CREATE_CMDB_GLOBAL_CAKE';

export const createCMDBGlobalCake = series => ({
    type: CREATE_CMDB_GLOBAL_CAKE,
    series
});

const CREATE_CMDB_GLOBAL_LAST13M = 'CREATE_CMDB_GLOBAL_LAST13M';

export const createCMDBLast13Months = (series, intl) => ({
    type: CREATE_CMDB_GLOBAL_LAST13M,
    series, intl
});

const CREATE_CMDB_BACKUP_CAKE_CHART = 'CREATE_CMDB_BACKUP_CAKE_CHART';

export const createCMDBBackupCakeChart = (series, intl) => ({
    type: CREATE_CMDB_BACKUP_CAKE_CHART,
    series, intl
});

const CREATE_CMDB_BACKUP_LAST13M_CHART = 'CREATE_CMDB_BACKUP_LAST13M_CHART';

export const createCMDBBackupLast13mChart = (series, intl) => ({
    type: CREATE_CMDB_BACKUP_LAST13M_CHART,
    series, intl
});

const CREATE_CMDB_MONITORING_CAKE_CHART = 'CREATE_CMDB_MONITORING_CAKE_CHART';

export const createCMDBMonitoringCakeChart = (series, intl) => ({
    type: CREATE_CMDB_MONITORING_CAKE_CHART,
    series, intl
});

const CREATE_CMDB_MONITORING_LAST13M_CHART = 'CREATE_CMDB_MONITORING_LAST13M_CHART';

export const createCMDBMonitoringLast13mChart = (series, intl) => ({
    type: CREATE_CMDB_MONITORING_LAST13M_CHART,
    series, intl
});

const CREATE_CMDB_PATCH_CAKE_CHART = 'CREATE_CMDB_PATCH_CAKE_CHART';

export const createCMDBPatchCakeChart = (series, intl) => ({
    type: CREATE_CMDB_PATCH_CAKE_CHART,
    series, intl
});

const CREATE_CMDB_PATCH_LAST13M_CHART = 'CREATE_CMDB_PATCH_LAST13M_CHART';

export const createCMDBPatchLast13mChart = (series, intl) => ({
    type: CREATE_CMDB_PATCH_LAST13M_CHART,
    series, intl
});

const _getDefaultState = () => ({
    CMDBGlobalCakeConfig:         undefined,
    CMDBGlobalLast13MonthsConfig: undefined,
    CMDBBackupCakeConfig:         undefined,
    CMDBBackupLast13mConfig:      undefined,
    CMDBMonitoringCakeConfig:     undefined,
    CMDBMonitoringLast13mConfig:  undefined,
    CMDBPatchCakeConfig:          undefined,
    CMDBPatchLast13mConfig:       undefined
});

export const reducer = (state = _getDefaultState(), action = {}) => {
    switch (action.type) {
    case CREATE_CMDB_GLOBAL_CAKE:
        return {
            ...state,
            CMDBGlobalCakeConfig: getChartCMDBGlobalCake(action.series)
        };
    case CREATE_CMDB_GLOBAL_LAST13M:
        return {
            ...state,
            CMDBGlobalLast13MonthsConfig: getChartCMDBGlobalLast13Months(action.series, action.intl)
        };
    case CREATE_CMDB_BACKUP_CAKE_CHART:
        return {
            ...state,
            CMDBBackupCakeConfig: getCMDBBackupCakeChart(action.series, action.intl)
        };
    case CREATE_CMDB_BACKUP_LAST13M_CHART:
        return {
            ...state,
            CMDBBackupLast13mConfig: getCMDBBackupLast13mChart(action.series, action.intl)
        };
    case CREATE_CMDB_MONITORING_CAKE_CHART:
        return {
            ...state,
            CMDBMonitoringCakeConfig: getCMDBMonitoringCakeChart(action.series, action.intl)
        };
    case CREATE_CMDB_MONITORING_LAST13M_CHART:
        return {
            ...state,
            CMDBMonitoringLast13mConfig: getCMDBMonitoringLast13mChart(action.series, action.intl)
        };
    case CREATE_CMDB_PATCH_CAKE_CHART:
        return {
            ...state,
            CMDBPatchCakeConfig: getCMDBPatchCakeChart(action.series, action.intl)
        };
    case CREATE_CMDB_PATCH_LAST13M_CHART:
        return {
            ...state,
            CMDBPatchLast13mConfig: getCMDBPatchLast13mChart(action.series, action.intl)
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/cmdb.js